import React, { useEffect, useRef, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import './Navbar.css';
import logo from '../../assets/logo/logonew.png';
import Icono from '../Icono';
import { enlaceWhatsApp } from '../../config/contacto';

// Cinco entradas y un botón: lo que una pyme busca (qué hacen, el ERP, quiénes
// son, cómo contactarlos) más el blog. Licencias y Productos salieron del menú
// por decisión de Adán (TESTI-14) y quedan enlazadas desde el pie y Servicios.
const enlaces = [
  { label: 'Servicios', to: '/servicios' },
  // Kiwi ERP es una página estática aparte (public/erp/, servida por nginx),
  // no una ruta de la SPA: va con <a href> para que el navegador la cargue entera.
  { label: 'Kiwi ERP', href: '/erp/' },
  { label: 'Nosotros', to: '/nosotros' },
  { label: 'Blog', to: '/blog' },
  { label: 'Contacto', to: '/contacto' },
];

// Sin MUI a propósito: el menú está en todas las páginas, y con AppBar/Drawer
// cada visita cargaba la librería completa antes de pintar el inicio.
function Navbar() {
  const [abierto, setAbierto] = useState(false);
  const [conSombra, setConSombra] = useState(false);
  const boton = useRef(null);
  const panel = useRef(null);
  const location = useLocation();

  // Cerrar el panel al cambiar de página.
  useEffect(() => {
    setAbierto(false);
  }, [location.pathname]);

  // La línea inferior aparece cuando el contenido pasa por debajo del menú.
  useEffect(() => {
    const alDesplazar = () => setConSombra(window.scrollY > 8);
    alDesplazar();
    window.addEventListener('scroll', alDesplazar, { passive: true });
    return () => window.removeEventListener('scroll', alDesplazar);
  }, []);

  // Con el panel abierto: Escape lo cierra, el foco entra al primer enlace y
  // la página de atrás no se desplaza.
  useEffect(() => {
    if (!abierto) return undefined;
    const alTeclear = (e) => {
      if (e.key === 'Escape') {
        setAbierto(false);
        boton.current?.focus();
      }
    };
    document.addEventListener('keydown', alTeclear);
    document.body.style.overflow = 'hidden';
    panel.current?.querySelector('a')?.focus();
    return () => {
      document.removeEventListener('keydown', alTeclear);
      document.body.style.overflow = '';
    };
  }, [abierto]);

  const claseEnlace = ({ isActive }) => `nav__enlace${isActive ? ' nav__enlace--activo' : ''}`;

  const renderEnlace = (item, alClic) =>
    item.href ? (
      <a href={item.href} className="nav__enlace" onClick={alClic}>
        {item.label}
      </a>
    ) : (
      <NavLink to={item.to} className={claseEnlace} onClick={alClic}>
        {item.label}
      </NavLink>
    );

  return (
    <header className={`nav${conSombra ? ' nav--sombra' : ''}`}>
      <div className="contenedor nav__barra">
        <Link to="/" className="nav__marca">
          <img src={logo} alt="Kiwi Dinámico, inicio" width="159" height="40" />
        </Link>

        <nav className="nav__escritorio" aria-label="Principal">
          <ul>
            {enlaces.map((item) => (
              <li key={item.label}>{renderEnlace(item)}</li>
            ))}
          </ul>
        </nav>

        <a
          className="btn btn--primario nav__cta"
          href={enlaceWhatsApp()}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Icono nombre="chat" />
          <span>WhatsApp</span>
        </a>

        <button
          ref={boton}
          type="button"
          className="nav__boton"
          aria-expanded={abierto}
          aria-controls="menu-movil"
          onClick={() => setAbierto((v) => !v)}
        >
          <Icono nombre={abierto ? 'cerrar' : 'menu'} />
          <span>{abierto ? 'Cerrar' : 'Menú'}</span>
        </button>
      </div>

      {/* El panel móvil solo existe en el DOM cuando está abierto: así no hay
          dos copias de cada enlace para los lectores de pantalla. */}
      {abierto && (
        <div id="menu-movil" ref={panel} className="nav__panel">
          <nav aria-label="Principal (móvil)">
            <ul>
              {enlaces.map((item) => (
                <li key={item.label}>{renderEnlace(item, () => setAbierto(false))}</li>
              ))}
            </ul>
          </nav>
          <a
            className="btn btn--primario nav__panel-cta"
            href={enlaceWhatsApp()}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Icono nombre="chat" />
            Hablemos por WhatsApp
          </a>
        </div>
      )}
    </header>
  );
}

export default Navbar;
